import React from 'react';
import { Row, Col } from 'react-bootstrap';
import classNames from 'classnames';

interface ModelScore {
  'Compliance Score': number;
  'Features Score': number;
  'Risk Score': number;
}

interface ModelScoresBySourceProps {
  scores: {
    [modelName: string]: ModelScore;
  };
}

const getColor = (model: string) => {
  const map: { [key: string]: string } = {
    ML: 'text-success',
    LLM: 'text-primary',
    NLP: 'text-info'
  };
  return map[model] || 'text-warning';
};

const ModelScoresBySource = ({ scores }: ModelScoresBySourceProps) => {
  const entries = Object.entries(scores);
  const gridItems = entries.flatMap(([model, data]) => [
    {
      label: `${model} - Compliance`,
      value: data['Compliance Score'],
      model
    },
    {
      label: `${model} - Features`,
      value: data['Features Score'],
      model
    },
    {
      label: `${model} - Risk`,
      value: data['Risk Score'],
      model
    }
  ]);

  return (
    <div>
      <h3>Model Scores by Type</h3>
      <p className="text-body-tertiary">
        Breakdown of compliance, features and risk by model
      </p>
      <Row className="g-0">
        {gridItems.map((item, index) => (
          <Col
            xs={6}
            xl={4}
            key={index}
            className={classNames('px-3 py-3 border-translucent', {
              'border-bottom': index < 3,
              'border-end': index % 3 !== 2
            })}
          >
            <span
              className={`me-2 fs-9 fw-semibold ${getColor(
                item.model
              )} d-inline-block`}
              style={{
                width: 10,
                height: 10,
                backgroundColor: 'currentColor',
                borderRadius: '50%'
              }}
            ></span>
            <span className="fs-9 text-body-secondary d-inline-block mb-1">
              {item.label}
            </span>
            <h4 className="mb-0 fw-bold">{item.value}</h4>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ModelScoresBySource;
